import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/404.svg';
const _withScopeId = n => (_pushScopeId("data-v-4a0eefbb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "error"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "error__inner"
};
const _hoisted_4 = {
  class: "error-wrapper"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "error-img",
  src: _imports_0,
  alt: "error"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "error-title"
}, [/*#__PURE__*/_createTextVNode("Ошибка 404."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Что-то пошло не так.")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "error-text"
}, "Страница, которую вы ищите, временно не доступна или ее еже нет", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("button", {
    class: "error-btn",
    onClick: _cache[0] || (_cache[0] = $event => this.$router.push('/rol-shop/'))
  }, "Вернуться на главную")])])])]);
}